import { render, staticRenderFns } from "./modelLoad.vue?vue&type=template&id=0e6209ce&scoped=true&lang=pug"
import script from "./modelLoad.vue?vue&type=script&lang=js"
export * from "./modelLoad.vue?vue&type=script&lang=js"
import style0 from "./modelLoad.vue?vue&type=style&index=0&id=0e6209ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6209ce",
  null
  
)

export default component.exports